import { CLEAR_SITE_DATA } from '../application';
import {
  RECEIVE_USER_EVENT_TYPES,
  IOT_EVENTS_UPDATED,
  RECEIVE_SERIES_EVENTS,
  RECEIVE_NOTIFY_EVENTS,
  FETCH_EXPORT_EVENTS,
  EXPORTING_DONE,
  EVENT_IMPORT_ERRORS,
  EVENT_IMPORTED_AT,
  SET_IMPORT_ORDER,
} from './actions';

// Initial state

const initialState = {
  iotUpdatedAt: undefined,
  userEventTypes: [],
  isExporting: false,
  seriesEvents: [],
  eventNotifications: {
    overdueCount: 0,
    todoCount: 0,
    notifiedEvents: [],
  },
  importErrors: [],
  importedAt: 0,
  order: 'desc',
};

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case RECEIVE_USER_EVENT_TYPES: {
      return { ...state, userEventTypes: action.userEventTypes };
    }
    case RECEIVE_SERIES_EVENTS: {
      return { ...state, seriesEvents: action.events };
    }
    case RECEIVE_NOTIFY_EVENTS: {
      return {
        ...state,
        eventNotifications: {
          ...state.eventNotifications,
          overdueCount: action.eventCounts.overdueCount,
          todoCount: action.eventCounts.todoCount,
          notifiedEvents: action.eventCounts.notifiedEvents,
        },
      };
    }
    case IOT_EVENTS_UPDATED: {
      return { ...state, iotUpdatedAt: action.updatedAt };
    }
    case FETCH_EXPORT_EVENTS: {
      return { ...state, isExporting: true };
    }
    case EXPORTING_DONE: {
      return { ...state, isExporting: false };
    }
    case EVENT_IMPORT_ERRORS: {
      return { ...state, importErrors: action.errors };
    }
    case EVENT_IMPORTED_AT: {
      return { ...state, importedAt: action.date };
    }
    case SET_IMPORT_ORDER: {
      return { ...state, order: action.order };
    }
    case CLEAR_SITE_DATA: {
      return structuredClone(initialState);
    }
    default: {
      return state;
    }
  }
}
